import { useState } from "react";

import HooksModalV5Key from "app/constants/HooksModalV5Key";
import { useCompanyName } from "app/pages/sales-intelligence/modules/company-analysis/hooks/useCompanyName";
import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import {
    type DigitalAssetType,
    digitalAssetTypeMap,
} from "app/pages/sales-intelligence/modules/company-analysis/types/digital-assets";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { openHooksModalV5 } from "app/services/ModalService";

const orderedTabIdList = [digitalAssetTypeMap.websites, digitalAssetTypeMap.apps] as const;

export const useDigitalAssetsTabSelection = () => {
    const companyName = useCompanyName();

    const [activeTab, setActiveTab] = useState<DigitalAssetType>(digitalAssetTypeMap.websites);

    const onTabSelect = (index: number) => {
        const tabId = orderedTabIdList[index];

        if (tabId === digitalAssetTypeMap.apps && !salesSettingsHelper.isConsolidatedAppsEnabled) {
            openHooksModalV5(HooksModalV5Key.AppLeadGenerator);
        } else {
            setActiveTab(tabId);
            companyAnalysisTrackingService.widgets.trackDigitalAssetsTabSwitch(companyName, tabId);
        }
    };

    return {
        activeTab,
        selectedTabIndex: orderedTabIdList.indexOf(activeTab),
        onTabSelect,
    };
};
